"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listAPIGroupInstances = exports.getUnderlyingAPIsTermsAndConditions = void 0;
exports.updateAPIGroupInstance = updateAPIGroupInstance;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _actionify = _interopRequireDefault(require("@mulesoft/exchange-ui-portals-store/lib/utils/actionify"));
var _exchangeApiClient = require("@mulesoft/exchange-api-client");
var actions = _interopRequireWildcard(require("./actionTypes"));
var _events = require("./events");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function trackAPIGroupVisibility(params, trackEvent) {
  var event = params.isPublic ? _events.API_GROUP_INSTANCE_MADE_PUBLIC : _events.API_GROUP_INSTANCE_MADE_PRIVATE;
  trackEvent(event, {
    organizationId: params.organizationId,
    groupId: params.groupId,
    assetId: params.assetId,
    version: params.version,
    name: params.name,
    originalFormat: params.originalFormat,
    originalFormatVersion: params.originalFormatVersion,
    type: params.type
  });
}
var listAPIGroupInstances = exports.listAPIGroupInstances = (0, _actionify.default)(_exchangeApiClient.InstanceService, function (service) {
  return service.listAPIGroupInstances;
}, actions.LIST_GROUP_INSTANCES, {
  once: true
});
var getUnderlyingAPIsTermsAndConditions = exports.getUnderlyingAPIsTermsAndConditions = (0, _actionify.default)(_exchangeApiClient.TermsService, function (service) {
  return service.getUnderlyingAPIsTermsAndConditions;
}, actions.GET_UNDERLYING_API_TERMS, {
  once: true
});
function updateAPIGroupInstance(params, trackEvent) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return dispatch((0, _actionify.default)(_exchangeApiClient.InstanceService, function (service) {
              return service.updateAPIGroupInstance;
            }, actions.UPDATE_API_GROUP_INSTANCE)(params));
          case 2:
            trackAPIGroupVisibility(params, trackEvent);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
//# sourceMappingURL=actions.js.map